export default __webpack_public_path__ + "static/media/logo_typo.f08ce743.svg";